// extracted by mini-css-extract-plugin
module.exports = {"loadMoreContainer":"TableLoadMore__loadMoreContainer--2mz","loadMoreBtn":"TableLoadMore__loadMoreBtn--3uQ"};